/**
 * Copyright 2014 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
export default {
   'en': {
      'date': 'MM/DD/YYYY',
      'time': 'h:mm A'
   },
   'ar-ma': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'ar': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'bg': {
      'date': 'D.MM.YYYY',
      'time': 'H:mm'
   },
   'br': {
      'date': 'DD/MM/YYYY',
      'time': 'h[e]mm A'
   },
   'bs': {
      'date': 'DD. MM. YYYY',
      'time': 'H:mm'
   },
   'ca': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'cs': {
      'date': 'DD.MM.YYYY',
      'time': 'H:mm'
   },
   'cv': {
      'date': 'DD-MM-YYYY',
      'time': 'HH:mm'
   },
   'da': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'de': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'el': {
      'date': 'DD/MM/YYYY',
      'time': 'h:mm A'
   },
   'en-au': {
      'date': 'DD/MM/YYYY',
      'time': 'h:mm A'
   },
   'en-ca': {
      'date': 'YYYY-MM-DD',
      'time': 'h:mm A'
   },
   'en-gb': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'eo': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'es': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'et': {
      'date': 'DD.MM.YYYY',
      'time': 'H:mm'
   },
   'eu': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'fa': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'fi': {
      'date': 'DD.MM.YYYY',
      'time': 'HH.mm'
   },
   'fr-ca': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'fr': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'gl': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'he': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'hi': {
      'date': 'DD/MM/YYYY',
      'time': 'A h:mm बजे'
   },
   'hr': {
      'date': 'DD. MM. YYYY',
      'time': 'H:mm'
   },
   'hu': {
      'date': 'YYYY.MM.DD.',
      'time': 'H:mm'
   },
   'id': {
      'date': 'DD/MM/YYYY',
      'time': 'HH.mm'
   },
   'is': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'it': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'ja': {
      'date': 'YYYY/MM/DD',
      'time': 'Ah時m分'
   },
   'ka': {
      'date': 'DD/MM/YYYY',
      'time': 'h:mm A'
   },
   'ko': {
      'date': 'YYYY.MM.DD',
      'time': 'A h시 mm분'
   },
   'lt': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'lv': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'ml': {
      'date': 'DD/MM/YYYY',
      'time': 'A h:mm -നു'
   },
   'mr': {
      'date': 'DD/MM/YYYY',
      'time': 'A h:mm वाजता'
   },
   'ms-my': {
      'date': 'DD/MM/YYYY',
      'time': 'HH.mm'
   },
   'nb': {
      'date': 'DD.MM.YYYY',
      'time': 'H.mm'
   },
   'ne': {
      'date': 'DD/MM/YYYY',
      'time': 'Aको h:mm बजे'
   },
   'nl': {
      'date': 'DD-MM-YYYY',
      'time': 'HH:mm'
   },
   'nn': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'pl': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'pt-br': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'pt': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'ro': {
      'date': 'DD/MM/YYYY',
      'time': 'H:mm'
   },
   'ru': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'sk': {
      'date': 'DD.MM.YYYY',
      'time': 'H:mm'
   },
   'sl': {
      'date': 'DD. MM. YYYY',
      'time': 'H:mm'
   },
   'sq': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'sv': {
      'date': 'YYYY-MM-DD',
      'time': 'HH:mm'
   },
   'th': {
      'date': 'YYYY/MM/DD',
      'time': 'H นาฬิกา m นาที'
   },
   'tr': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'tzm-la': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'tzm': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'uk': {
      'date': 'DD.MM.YYYY',
      'time': 'HH:mm'
   },
   'uz': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'vn': {
      'date': 'DD/MM/YYYY',
      'time': 'HH:mm'
   },
   'zh-cn': {
      'date': 'YYYY年MMMD日',
      'time': 'Ah点mm'
   },
   'zh-tw': {
      'date': 'YYYY年MMMD日',
      'time': 'Ah點mm'
   }
};



// WEBPACK FOOTER //
// ./lib/moment_formats.js